export default [{
  path: 'portalApplication',
  name: 'portalApplication',
  component: () => import('@/views/portal/application/index.vue')
}, {
  path: 'portalAccount',
  name: 'portalAccount',
  component: () => import('@/views/portal/account/index.vue')
}, {
  path: 'exportAccount',
  name: 'exportAccount',
  component: () => import('@/views/portal/account/indexOut.vue')
}]